import { normalizeObjUUID } from 'ducks/utils';

export function normalizeFile(file: { ending_byte: number }) {
  const { ending_byte } = file;
  const new_file = normalizeObjUUID({ ...file, ending_byte });
  return new_file;
}
